__webpack_require__.p = "/marketplace-feature-discovery/referrals-hub/";